<template>
  <div class="supplier" v-loading="loading">
    <div class="supplier-first">
      <div class="supplier-first-top">
        <div
          class="top-list"
          v-for="(item, index) in supplierTitleArray"
          :key="index"
          :class="{ active: supplierTitleIndex == index }"
          @click="titleBtn(index)"
        >
          <div class="top-list-title">{{ item }}</div>
          <div class="top-list-lint" v-if="supplierTitleIndex == index"></div>
        </div>
      </div>

      <div class="supplier-first-center">
        <div class="first-center-list" v-for="(item, index) in 5" :key="index">
          <div class="first-center-list-title">
            {{
              index == 0
                ? '供应商名称'
                : index == 1
                ? '供应商电话'
                : index == 2
                ? '对接人'
                : index == 3
                ? '合作开始日期'
                : index == 4
                ? '合作截止日期'
                : ''
            }}
          </div>

          <div class="first-center-list-input">
            <el-input
              v-if="index == 0"
              placeholder="请输入供应商名称"
              v-model="supplierName"
              clearable
            ></el-input>

            <el-input
              v-if="index == 1"
              placeholder="请输入供应商电话"
              v-model="supplierPhone"
              clearable
            ></el-input>

            <el-input
              v-if="index == 2"
              placeholder="请输入对接人"
              v-model="supplierAbutment"
              clearable
            ></el-input>

            <el-date-picker
              v-if="index == 3"
              value-format="yyyy-MM-dd"
              v-model="supplierbeginTime"
              type="daterange"
              range-separator
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>

            <el-date-picker
              v-if="index == 4"
              value-format="yyyy-MM-dd"
              v-model="supplierabortTime"
              type="daterange"
              range-separator
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </div>
      </div>

      <div class="supplier-first-bottom">
        <div class="first-bottom-inquire" @click="btnsupplier()">查询</div>
        <div class="first-bottom-reset" @click="clear()">重置</div>
      </div>
    </div>

    <div class="supplier-second">
      <div class="supplier-second-div">
        <div class="supplier-second-div-left">查询结果</div>
        <div class="supplier-second-div-right" @click="addtionBtn">
          <img class="addition-img" src="../../assets/common/common-add.png" />
          <div class="addition-text">添加</div>
        </div>
      </div>

      <div class="supplier-second-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>

          <el-table-column prop="A" label="供应商id" width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.id }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="B" label="供应商名称" width="224">
            <template slot-scope="scope">
              <div>{{ scope.row.suppname }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="C" label="对接人" width="136">
            <template slot-scope="scope">
              <div>{{ scope.row.djrname }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="D" label="供应商电话" width="198">
            <template slot-scope="scope">
              <div>{{ scope.row.phone }}</div>
            </template>
          </el-table-column>
          <el-table-column prop label="运费模板" width="146">
            <template slot-scope="scope">
              <div class="table-freight" @click="freightSetBtn(scope.row)">
                设置
              </div>
            </template>
          </el-table-column>
          <!-- 状态:1=正常,2=下架商品,3=停止合作 -->
          <el-table-column prop="E" label="状态" width="128">
            <template slot-scope="scope">
              <div
                class="table-status"
                :style="{
                  color:
                    scope.row.status == 2
                      ? '#F9B63C'
                      : scope.row.status == 1
                      ? '#36C100'
                      : scope.row.status == 6
                      ? '#FF4133'
                      : scope.row.status == 3
                      ? '#999999'
                      : '',
                }"
              >
                {{
                  scope.row.status == 2
                    ? '合作到期'
                    : scope.row.status == 1
                    ? '合作中'
                    : scope.row.status == 6
                    ? '即将到期'
                    : scope.row.status == 3
                    ? '终止合作'
                    : ''
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="F" label="合作开始日期" width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.createtime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="G" label="合作截止日期" width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.jztime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="H" label="最后操作时间" width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.updatetime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="I" label="最后操作人" width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.admin_name }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="198">
            <template slot-scope="scope">
              <div class="operation">
                <div class="compile" @click="compileBtn(scope.row)">编辑</div>
                <div
                  v-if="scope.row.status != 3"
                  class="delete"
                  @click="terminationBtn(scope.row)"
                >
                  终止合作
                </div>

                <div
                  v-if="scope.row.status == 3"
                  class="delete"
                  @click="deteleBtn(scope.row)"
                >
                  删除
                </div>
                <div
                  v-if="scope.row.status == 3"
                  class="delete"
                  @click="continueBtn(scope.row)"
                >
                  继续合作
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagelist">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginations.page_index"
          :page-sizes="[10]"
          :page-size="paginations.page_size"
          layout="total,
           sizes, prev, pager, next"
          :total="paginations.total"
          class="pagebg"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加弹出框 -->
    <div class="addition">
      <el-dialog :visible.sync="additionDialogVisible" style="margin-top: 10vh">
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="addition-div-top-title">
                {{ compileShow == false ? '添加' : '编辑' }}
              </div>
              <img
                class="addition-div-top-img"
                src="../../assets/common/close.png"
                @click="close"
              />
            </div>

            <div class="addition-div-center">
              <div class="div-center-display">
                <div class="div-center-display-left">
                  <div class="display-left-title">供应商名称</div>
                  <div class="display-left-input">
                    <el-input
                      placeholder="请输入供应商名称"
                      v-model="additionSupplierName"
                      class="input-with-select"
                    ></el-input>
                  </div>
                </div>
                <div class="div-center-display-right">
                  <div class="display-right-title">对接人</div>
                  <div class="display-right-input">
                    <el-input
                      placeholder="请输入对接人"
                      v-model="additionSupplierAbutment"
                      class="input-with-select"
                    ></el-input>
                  </div>
                </div>
              </div>

              <div class="div-center-display">
                <div class="div-center-display-left">
                  <div class="display-left-title">供应商电话</div>
                  <div class="display-left-input">
                    <el-input
                      placeholder="请输入供应商电话"
                      v-model="additionSupplierPhone"
                      class="input-with-select"
                    ></el-input>
                  </div>
                </div>
                <div class="div-center-display-right">
                  <div class="display-right-title">合作开始日期</div>
                  <div class="display-right-input">
                    <el-date-picker
                      v-model="additionSupplierbeginTime"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </div>
                </div>
              </div>

              <div class="div-center-display">
                <div class="div-center-display-left">
                  <div class="display-left-title">合作截止日期</div>
                  <div class="display-left-input">
                    <el-date-picker
                      v-model="additionSupplierabortTime"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="addition-div-button">
              <!-- <div class="addition-div-button-left" @click="btnreturn">重 置</div> -->
              <div class="addition-div-button-right" @click="addsupplier">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!-- 终止合作 -->
    <div class="termination">
      <el-dialog
        :visible.sync="terminationDialogVisible"
        style="margin-top: 10vh"
      >
        <span slot="footer" class="dialog-footer">
          <div class="termination-div">
            <img
              class="termination-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="termination-div-title">
              是否确定与该供应商终止合作？
            </div>
            <div class="termination-div-text">
              一旦确定后，该供应商所有的商品都将进行下架为仓库中，请谨慎操作。
            </div>
            <div class="termination-div-button">
              <div class="termination-div-button-left" @click="endsupplier">
                确定
              </div>
              <div class="termination-div-button-right" @click="endqxsupplier">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!-- 删除 -->
    <div class="termination">
      <el-dialog :visible.sync="deteleDialogVisible" style="margin-top: 10vh">
        <span slot="footer" class="dialog-footer">
          <div class="termination-div">
            <img
              class="termination-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="termination-div-title">是否删除该供应商？</div>
            <div class="termination-div-text">
              一旦删除后，则该供应商所有的
              商品都将进行下架并且删除，请谨慎操作。
            </div>
            <div class="termination-div-button">
              <div
                class="termination-div-button-left"
                @click="deletesupplier()"
              >
                确定
              </div>
              <div class="termination-div-button-right" @click="deteleDialogVisible = false">取消</div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--继续合作-->
    <div class="termination">
      <el-dialog :visible.sync="continueDialogVisible" style="margin-top: 10vh">
        <span slot="footer" class="dialog-footer">
          <div class="termination-div">
            <img
              class="termination-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="termination-div-title">
              是否确定与该供应商继续合作？
            </div>
            <div class="termination-div-text">
              一旦确定后，该供应商所有的商品自动重新上架。
            </div>
            <div class="termination-div-button">
              <div class="termination-div-button-left" @click="continueConfirm">
                确定
              </div>
              <div class="termination-div-button-right"  @click="continueDialogVisible = false">取消</div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!-- 分页 -->
  </div>
</template>

<script>
import Bus from '../../utils/bus'
import {
  getsupplier,
  postsupplier,
  endsupplier,
  putsupplier,
  deletesupplier,
} from '../../api/supplier'
import { isNotNull } from '../../utils/componet'
export default {
  data() {
    return {
      //控制当前页面功能性按钮开关
      suppliershow: true,
      // 监听用户刷新
      loading: false,
      // 第一区域 标题数组
      supplierTitleArray: ['合作中', '即将到期', '合作到期', '终止合作'],
      // 第一区域 标题数组下标
      supplierTitleIndex: 0,
      // 第一区域 供应商名称
      supplierName: '',
      // 第一区域 供应商电话
      supplierPhone: '',
      // 第一区域 对接人
      supplierAbutment: '',
      // 第一区域 合作开始日期
      supplierbeginTime: [],
      supplierbeginTimeA: '',
      supplierbeginTimeB: '',
      // 第一区域 合作截止日期
      supplierabortTime: [],
      supplierabortTimeA: '',
      supplierabortTimeB: '',
      // 第二区域 表格区域
      tableData: [],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: null, // 总数
        page_size: 10, // 1页显示多少条
        // page_sizes: [5, 10, 15, 20], //每页显示多少条
        // layout: 'total, sizes, prev, pager, next, jumper' // 翻页属性
      },
      // 添加弹出框  开启关闭
      additionDialogVisible: false,
      // 添加弹出框  供应商名称
      additionSupplierName: '',
      // 添加弹出框  对接人
      additionSupplierAbutment: '',
      // 添加弹出框  供应商电话
      additionSupplierPhone: '',
      // 添加弹出框  合作开始日期
      additionSupplierbeginTime: '',
      // 添加弹出框  合作截止日期
      additionSupplierabortTime: '',

      // 第二区域 终止合作弹出框
      terminationDialogVisible: false,
      // 第二区域 编辑弹出框 判断当前是添加还是编辑
      compileShow: false,
      // 第二区域 删除弹出框
      deteleDialogVisible: false,
      // 第二区域 继续合作弹出框
      continueDialogVisible: false,
      endsupplierid: '', //终止合作id
      showsupplierid: '', //继续合作id

      // 分页功能
      page: 1,
      limit: 10,
      // 分类下标接口请求参数
      titleIndex: 1,
      // 暂时存储继续合作对象
      showsupplierObj: {},
    }
  },
  created() {
    this.loading = true
    this.getManagement()

    setTimeout(() => {
    this.suppliershow = this.$store.state.pageFunctionShow

    }, 1000);

  },
  methods: {
    getManagement() {
      let params = {
        suppname: this.supplierName,
        phone: this.supplierPhone,
        djrname: this.supplierAbutment,
        createStartTime: this.supplierbeginTimeA,
        createEndTime: this.supplierbeginTimeB,
        endStartTime: this.supplierabortTimeA,
        endEndTime: this.supplierabortTimeB,
        pageSize: this.limit,
        pageNo: this.page,
        status: this.titleIndex, // 1 全部  6 即将到期 2合作到期 3终止合作
      }
      getsupplier(params).then((res) => {
        if (res.resultStatus == true) {
          this.tableData = res.resultData.supplierList
          this.paginations.total = parseInt(res.resultData.totalNum)
          this.loading = false
        }
      })
    },
    // 重置搜索数据
    clear() {
      this.supplierName = ''
      this.supplierPhone = ''
      this.supplierAbutment = ''
      //   this.supplierbeginTime = ''
      //   this.supplierabortTime = ''
    },
    //关闭按钮
    close() {
      this.additionDialogVisible = false
    },
    //添加列表数据重置
    btnreturn() {
      this.additionSupplierName = ''
      this.additionSupplierAbutment = ''
      this.additionSupplierPhone = ''
      this.additionSupplierbeginTime = ''
      this.additionSupplierabortTime = ''
    },
    //添加供应商数据
    addsupplier() {
      if (this.additionSupplierPhone == !isNotNull) {
        console.log('手机不能为空2')
      } else if (this.additionSupplierName == !isNotNull) {
        console.log('供应商名字不能为空')
      } else if (this.additionSupplierAbutment == !isNotNull) {
        console.log('对接人')
      } else if (this.additionSupplierbeginTime == !isNotNull) {
        console.log('供应商id不能为空5')
      } else if (this.additionSupplierabortTime == !isNotNull) {
        console.log('供应商id不能为空6')
      } else {
        let params = {
          id: this.showsupplierid,
          phone: this.additionSupplierPhone,
          suppname: this.additionSupplierName,
          djrname: this.additionSupplierAbutment,
          createtime: this.additionSupplierbeginTime,
          jztime: this.additionSupplierabortTime,
        }
        postsupplier(params).then((res) => {
          if (res.resultStatus == true) {
            this.loading = true
            this.additionDialogVisible = false
            // this.$message({
            //   message: '添加成功！',
            //   type: 'success',
            //   duration: 2000,
            // })
            this.getManagement()
          }
        })
      }
    },
    // 用户点击查询
    btnsupplier() {
      console.log('点击查询合作开始时间', this.supplierabortTime)
      if (this.supplierbeginTime != null) {
        this.supplierbeginTimeA = this.supplierbeginTime[0]
        this.supplierbeginTimeB = this.supplierbeginTime[1]
      } else {
        this.supplierbeginTimeA = ''
        this.supplierbeginTimeB = ''
      }

      if (this.supplierabortTime != null) {
        this.supplierabortTimeA = this.supplierabortTime[0]
        this.supplierabortTimeB = this.supplierabortTime[1]
      } else {
        this.supplierabortTimeA = ''
        this.supplierabortTimeB = ''
      }

      this.loading = true
      this.page = 1
      this.getManagement()
    },
    // 点击对应分类进行切换
    titleBtn(index) {
      this.supplierTitleIndex = index

      if (index == 0) {
        this.titleIndex = 1
      } else if (index == 1) {
        this.titleIndex = 6
      } else if (index == 2) {
        this.titleIndex = 2
      } else {
        this.titleIndex = 3
      }
      this.page = 1
      this.getManagement()
    },
    // 点击添加弹出框
    addtionBtn() {
      if (this.suppliershow == true) {
        // 添加弹出框  供应商名称
        this.additionSupplierName = ''
        // 添加弹出框  对接人
        this.additionSupplierAbutment = ''
        // 添加弹出框  供应商电话
        this.additionSupplierPhone = ''
        // 添加弹出框  合作开始日期
        this.additionSupplierbeginTime = ''
        // 添加弹出框  合作截止日期
        this.additionSupplierabortTime = ''
        this.additionDialogVisible = true
      }
    },

    /* 终止合作 */
    // 开启终止合作弹出框
    terminationBtn(e) {
      if (this.suppliershow == true) {
        this.terminationDialogVisible = true
        this.endsupplierid = e.id
      }
    },
    endsupplier() {
      let params = this.endsupplierid
      endsupplier(params).then((res) => {
        if (res.resultStatus == true) {
          this.terminationDialogVisible = false
          this.loading = true
          this.getManagement()
          // this.$message({
          //   message: '终止成功！',
          //   type: 'success',
          //   duration: 2000,
          // })
        }
      })
    },
    endqxsupplier() {
      this.terminationDialogVisible = false
    },
    /* 编辑 */
    // 开启编辑弹出框
    compileBtn(index) {
      if (this.suppliershow == true) {
        this.compileShow = true
        // 添加弹出框  供应商名称
        this.additionSupplierName = index.suppname
        // 添加弹出框  对接人
        this.additionSupplierAbutment = index.admin_name
        // 添加弹出框  供应商电话
        this.additionSupplierPhone = index.phone
        // 添加弹出框  合作开始日期
        this.additionSupplierbeginTime = index.createtime
        // 添加弹出框  合作截止日期
        this.additionSupplierabortTime = index.jztime
        this.showsupplierid = index.id
        this.additionDialogVisible = true
      }
    },
    /* 删除 */
    deteleBtn(e) {
      if (this.suppliershow == true) {
        this.deteleDialogVisible = true
        this.showsupplierid = e.id
      }
    },
    deletesupplier() {
      let params = this.showsupplierid
      deletesupplier(params).then((res) => {
        this.deteleDialogVisible = false
        this.loading = true
        this.getManagement()
        // this.$message({
        //   message: '删除成功！',
        //   type: 'success',
        //   duration: 2000,
        // })
      })
    },
    /* 继续合作按钮 */
    continueBtn(e) {
      console.log('点击继续合作', e)
      if (this.suppliershow == true) {
        this.continueDialogVisible = true
        this.showsupplierid = e.id
        this.showsupplierObj = e
      }
    },
    /* 确定 */
    continueConfirm() {
      let time = parseInt(new Date().getTime() / 1000) + ''

      // 开始时间
      let timeA =
        parseInt(new Date(this.showsupplierObj.createtime).getTime() / 1000) +
        ''
      // 截止日期
      let timeB =
        parseInt(new Date(this.showsupplierObj.jztime).getTime() / 1000) + ''

      if (timeB > time && timeB > timeA) {
        let params = this.showsupplierid
        putsupplier(params).then((res) => {
          this.continueDialogVisible = false
          this.loading = true
          this.getManagement()
        })
      } else {
        this.$message({
          message:
            '抱歉，该供应商的合作截止时间已到期，请重新编辑合作延长截止时间进行操作。注意：合作截止时间＞实时时间，合作截止时间＞合作开始时间',
          type: 'error',
          duration: 2000,
        })
      }
    },

    /* 运费模板 */
    freightSetBtn(e) {
      Bus.$emit('log', 'supplierFreightset', e)
      // if (this.suppliershow == true) {
      //   Bus.$emit('log', 'supplierFreightset', e)
      // }
    },

    //  查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getManagement()
      console.log(`每页 ${val} 条`)
    },
    //  查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getManagement()
      console.log(`当前页: ${val}`)
    },
  },
}
</script>


<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.supplier {
  .supplier-first {
    height: 236px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    box-sizing: border-box;

    .supplier-first-top {
      display: flex;
      height: 55px;
      border-bottom: 1px solid #f4f5f9;
      .top-list {
        width: 66px;
        height: 55px;
        position: relative;
        margin-right: 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        .top-list-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .top-list-lint {
          position: absolute;
          bottom: 0;
          width: 56px;
          height: 4px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 15px 15px 0px 0px;
        }
      }

      .active {
        .top-list-title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }
      }
    }

    .supplier-first-center {
      display: flex;
      margin-top: 30px;
      .first-center-list {
        margin-right: 25px;
        .first-center-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .first-center-list-input {
          width: 100%;
          margin-top: 4px;
          /deep/ .el-input {
            height: 32px;
            width: 180px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }

          /deep/ .el-range-editor.el-input__inner {
            padding: 0;
            padding: 0 12px;
            box-sizing: border-box;
          }

          /deep/ .el-date-editor--daterange.el-input__inner {
            width: 100%;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 26px;
            padding: 0;
            height: 32px;
            line-height: 32px;
            background-image: url('../../assets/activities/activities-right.png');
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .first-center-list:last-child {
        margin-right: 0;
      }
    }

    .supplier-first-bottom {
      display: flex;
      margin-top: 27px;

      .first-bottom-inquire,
      .first-bottom-reset {
        width: 110px;
        height: 36px;
        background: #222222;
        border-radius: 10px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .first-bottom-reset {
        background: #f4f5f9;
        margin-left: 10px;
        color: #999999;
      }
    }
  }

  .supplier-second {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 24px;
    .supplier-second-div {
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      box-sizing: border-box;

      .supplier-second-div-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .supplier-second-div-right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 82px;
        height: 36px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        cursor: pointer;
        .addition-img {
          width: 13px;
          height: 13px;
        }

        .addition-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }

    .supplier-second-table {
      padding: 0 24px;
      padding-bottom: 24px;
      box-sizing: border-box;
      /deep/ .el-table .el-table__cell {
        padding: 13px 0 0;
        vertical-align: top;
      }
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-freight {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
      }

      .table-sort {
        display: flex;

        .table-sort-left,
        .table-sort-right {
          width: 23px;
          height: 23px;
        }

        .table-sort-right {
          margin-left: 4px;
        }
      }

      .operation {
        display: flex;

        .compile,
        .delete {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        .delete {
          margin-left: 24px;
        }
      }
    }
  }

  /* 添加弹出框 */
  .addition {
    /deep/ .el-dialog {
      width: 590px;
      height: 350px;
      background: #ffffff;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }
    .addition-div {
      .addition-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .addition-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .addition-div-top-img {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }

      .addition-div-center {
        margin-top: 20px;
        padding: 0 24px;
        box-sizing: border-box;
        .div-center-display {
          display: flex;
          margin-bottom: 14px;
          .div-center-display-left {
            width: 100%;
            .display-left-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .display-left-input {
              margin-top: 4px;
              width: 100%;

              /deep/ .el-input {
                height: 32px;
                width: 254px;
              }

              /deep/ .el-input__inner {
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-select .el-input.is-focus .el-input__inner {
                border-color: rgba(217, 217, 217, 1);
              }

              /deep/ .el-input__icon {
                display: flex;
                align-items: center;
              }
            }
          }

          .div-center-display-right {
            margin-left: 24px;
            width: 100%;
            .display-right-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .display-right-input {
              margin-top: 4px;

              /deep/ .el-input {
                height: 32px;
                width: 254px;
              }

              /deep/ .el-input__inner {
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-select .el-input.is-focus .el-input__inner {
                border-color: rgba(217, 217, 217, 1);
              }

              /deep/ .el-date-editor--daterange.el-input__inner {
                width: 100%;
              }

              /deep/ .el-date-editor.el-input {
                width: 100%;
              }

              /deep/ .el-input__icon {
                display: flex;
                align-items: center;
              }
            }
          }
        }
      }

      .addition-div-button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        height: 52px;
        border-top: 1px solid #e9edf4;
        margin-top: 22px;

        .addition-div-button-left,
        .addition-div-button-right {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .addition-div-button-right {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
  }
  /* 终止合作弹出框 */
  .termination {
    /deep/ .el-dialog {
      width: 394px;
      height: 230px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .termination-div {
      width: 100%;
      text-align: center;
      .termination-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .termination-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }

      .termination-div-text {
        width: 319px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;
      }

      .termination-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .termination-div-button-left,
        .termination-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .termination-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
  .pagelist {
    margin: 0px 0 20px 30%;

    height: 50px;
  }
  /deep/.el-pagination.is-background .btn-next {
    color: rgba(0, 0, 0, 0.65);
    border: 1px solid #d9d9d9;
    background-color: #ffffff;
  }
  /deep/.el-pagination.is-background .btn-prev {
    color: rgba(0, 0, 0, 0.65);
    border: 1px solid #d9d9d9;
    background-color: #ffffff;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #ffffff;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    border: 1px solid #d9d9d9;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #000000;
    color: #fff;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: none;
  }
  /* 编辑 */
}
</style>
